import React from 'react';
import PropTypes from 'prop-types';
import NoteDisplayBeat from './NoteDisplayBeat';
import NoteDisplayNames from './NoteDisplayNames';
export default class NoteDisplay extends React.Component {
	static propTypes = {
		name: PropTypes.string,
	};
	constructor(props) {
		super(props);
		//setInterval(() => {
		//	var beat = this.state.beat+1;
		//	if(beat > 15) beat = 0;
		//	this.setState({
		//		beat: beat
		//	});
		//}, 125);

	}

	render() {

		var beats = [], i, data, preBeat = (this.props.bar-1)*16;

		for (i = 0; i < 16; i++) {
			data = {
				key: i,
				beat: i,
				bar: this.props.bar,
				notes: this.props.grid[i]
			};
			if(i+preBeat == this.props.beat) {
				beats.push(
					<NoteDisplayBeat active {...data}/>
				);
			} else {
				beats.push(
					<NoteDisplayBeat {...data}/>
				);
			}

		};

		return (
	  		<div className="NoteDisplay">
				<NoteDisplayNames names={this.props.names}/>
				<div className="beats">
					{beats}
				</div>

	  		</div>
		);
	}
}
